import React from 'react'
import { Button, useOverlay, DialogOverlay, DialogOverlayContent } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

const buttonWrapper = css`
  display: flex;
  justify-content: center;
  padding: 25px;
`

export default function DeleteMemoryButton({ artifactId, deleteMemory }) {
  const [t] = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <Button onClick={overlay.open}>{t('shared.delete', 'Delete')}</Button>
      <DialogOverlay {...overlay} headingText={t('shared.delete.memories', 'Delete Memories.')}>
        <DialogOverlayContent>
          {t(
            'shared.delete.warning',
            'Deleting this memory also deletes the associated tags, dates, and places. All deleted items go in the Recently Deleted collection located in your Gallery for 120 days before permanent deletion.'
          )}
        </DialogOverlayContent>
        <div css={buttonWrapper}>
          <Button
            type="submit"
            emphasis="destroy"
            onClick={() => {
              deleteMemory({ artifactId })
              overlay.close()
            }}
          >
            {t('shared.delete.fs', 'Delete From FamilySearch')}
          </Button>
          <Button onClick={overlay.close}>{t('shared.cancel', 'Cancel')}</Button>
        </div>
      </DialogOverlay>
    </>
  )
}
